export const PRODUCT_COMPARISON_DURABILITY_FIELDS = [
  'year_date_release',
  'last_os_compatibility',
  'os',
  'macbook_maximum_os_supported',
  'foldable',
  'ipad_maximum_os',
]
export const PRODUCT_COMPARISON_DURABILITY_CAT_INFOS = {
  110: 'durabilityMacbookImportance',
  528: 'durabilityMacbookImportance',
  2: 'durabilitySmartphoneImportance',
  5: 'durabilityIpadImportance',
}
export const PRODUCT_COMPARISON_PERFORMANCE_FIELDS = [
  'memory',
  'processor',
  'processor_type',
  'ipad_processor',
  'graphic_card',
  'macbook_architecture',
]
export const PRODUCT_COMPARISON_PERFORMANCE_CAT_INFOS = {
  110: 'performancesMacbookImportance',
  528: 'performancesMacbookImportance',
  2: 'performancesSmartphoneImportance',
  5: 'performancesIpadImportance',
}
export const PRODUCT_COMPARISON_SCREEN_QUALITY_FIELDS = [
  'resolution',
  'ips',
  'macbook_brightness',
  'macbook_screen_type',
  'macbook_true_tone',
  'promotion',
  'retina',
  'screen_type',
  'pixel_density',
  'ipad_brightness',
  'display_glass',
]
export const PRODUCT_COMPARISON_SCREEN_QUALITY_CAT_INFOS = {
  110: 'screenPerformancesMacbookImportance',
  528: 'screenPerformancesMacbookImportance',
  2: 'screenPerformancesSmartphoneImportance',
  5: 'screenPerformancesIpadImportance',
}
export const PRODUCT_COMPARISON_SOUND_QUALITY_FIELDS = ['ipad_speakers']
export const PRODUCT_COMPARISON_SOUND_QUALITY_CAT_INFOS = {
  5: 'soundQualityIpadImportance',
}
export const PRODUCT_COMPARISON_MULTIMEDIA_FIELDS = [
  'macbook_front_camera_video_definition',
  'macbook_speakers',
]
export const PRODUCT_COMPARISON_MULTIMEDIA_CAT_INFOS = {
  110: 'multimediaMacbookImportance',
  528: 'multimediaMacbookImportance',
}
export const PRODUCT_COMPARISON_CAMERA_FIELDS = ['main_camera', 'front_camera']
export const PRODUCT_COMPARISON_CAMERA_CAT_INFOS = {
  2: 'cameraSmartphoneImportance',
}
export const PRODUCT_COMPARISON_MISCELANEOUS_FIELDS = [
  'touch_bar',
  'hdmi_output',
  'face_id',
  'touch_id',
  'ipad_connector',
  'connector',
]
